import React from 'react';
import { VideoProgressNotification } from './VideoProgressNotification';
import { useSelector } from 'react-redux';
import { RootState } from '../../index';
import { VideoManagerState } from '../../store/videoManagerSlice';

interface VideoImportProgressProps {
}

const VideoImportProgressWS: React.FC<VideoImportProgressProps> = () => {

  const {
    uploadVideos, importVideos
  } = useSelector<RootState, VideoManagerState>((state) => state.videoManager);

  return (
    <VideoProgressNotification videos={[...importVideos, ...uploadVideos]}/>
  );
};

export default VideoImportProgressWS;